/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { SectionRecommendation } from './sectionRecommendation';

export class MenuRecommendation extends DaoModel {
  constructor(guid, sections, name) {
    super(guid); // guid of menu, not guid of menu recommendation
    this.sections = sections || [];
    this.name = name || '';
  }

  static toInstance(props = {}) {
    const sections = SectionRecommendation.toInstanceList(props.sections);
    return new MenuRecommendation(props.guid, sections, props.name);
  }

  serialize() {
    return {
      ...super.serialize(),
      sections: this.sections.map((section) => section.serialize()),
      name: this.name,
    };
  }

  hasChange() {
    return this.sections.some((s) => s.hasChange());
  }

  getChanges() {
    return this.sections.map((section) => section.getChange());
  }
}
